export default {
  paged: {
    select: 'id,isActive,name,approvalStatus,agreementType,ownerType',
    searchSelect: ['name'],
    orderBy: 'name asc',
  },
  itemDetail: {},
};
